export const SORTABLE_INSTRUCTIONS = {
  draggable: "To reorder, press space or enter to pick this up. Use the up and down arrow keys to move it, then space or enter to drop it, or escape to cancel.",
};

export default function sortableAnnouncements(keys, labelFor) {
  const place = (id) => `position ${keys.indexOf(id) + 1} of ${keys.length}`;
  return {
    onDragStart: ({ active }) => `Picked up ${labelFor(active.id)}, in ${place(active.id)}.`,
    onDragOver: ({ active, over }) => (over ? `${labelFor(active.id)} moved to ${place(over.id)}.` : `${labelFor(active.id)} is not over a position.`),
    onDragEnd: ({ active, over }) => (over ? `Moved ${labelFor(active.id)} to ${place(over.id)}.` : `Dropped ${labelFor(active.id)}.`),
    onDragCancel: ({ active }) => `Cancelled. ${labelFor(active.id)} stays in ${place(active.id)}.`,
  };
}
